import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

export const TRIGGER_ARTICLE_GENERATION_FOR_TOPICS =
	'state.actions.trigger-article-generation-for-topics.TRIGGER_ARTICLE_GENERATION_FOR_TOPICS' as const;

export type TriggerArticleGenerationPayload = {
	projectId: number;
	analyticsEvent: UIAnalyticsEvent;
	activationId: string;
};
export type TriggerArticleGenerationAction = {
	type: typeof TRIGGER_ARTICLE_GENERATION_FOR_TOPICS;
	payload: TriggerArticleGenerationPayload;
};

export const triggerArticleGenerationForTopics = (
	payload: TriggerArticleGenerationPayload,
): TriggerArticleGenerationAction => ({
	type: TRIGGER_ARTICLE_GENERATION_FOR_TOPICS,
	payload,
});
